import React, { useContext } from "react";
import { Form } from "reactstrap";

import InputWrapper from "features/forms/components/InputWrapper";

import { EmployeeDataContext } from "./employees/CompanyEmployeesContext";
import { MultiCheckboxes } from "features/forms/components/InputElement";
import { SelectorElement } from "features/forms/components/InputElement";

import { useFormContext } from "react-hook-form";

const UserRoleAndPrivileges = () => {
	const {
		selectedRole,
		privilegeOptions,
		bhphPrivilegeOptions,
		setSelectedRole,
		setSelectedPrivileges,
		setSelectedBhphPrivileges,
	} = useContext(EmployeeDataContext);

	const roles = [
		{ label: "Administrator", value: "admin" },
		{ label: "Employee", value: "user" },
	];

	const methods = useFormContext();

	return (
		<Form>
			<InputWrapper
				formTitle="Role & Privilege(s)"
				inputComponents={[
					<div className="col-12 d-flex justify-content-center align-items-center mb-3">
						<SelectorElement
							{...methods}
							colSize="col-sm-4"
							value={selectedRole}
							name="employeeRole"
							selectText="Select new user's role"
							onChange={(e) => setSelectedRole(e.target.value)}
							options={roles}
						/>
					</div>,
					<>
						{selectedRole !== "admin" && (
							<MultiCheckboxes
								labelClass="pl-3 required"
								colSize="col-3 px-6"
								options={privilegeOptions}
								onChange={(e) =>
									setSelectedPrivileges((prev) => ({
										...prev,
										[e.target.value]: !prev[e.target.value],
									}))
								}
							/>
						)}
					</>,
					<br />,
					<>
						{selectedRole !== "admin" && (
							<MultiCheckboxes
								labelClass="pl-3 required"
								colSize="col-3 px-6"
								options={bhphPrivilegeOptions}
								onChange={(e) =>
									setSelectedBhphPrivileges((prev) => ({
										...prev,
										[e.target.value]: !prev[e.target.value],
									}))
								}
							/>
						)}
					</>,
				]}
			/>
		</Form>
	);
};

export default UserRoleAndPrivileges;
